<script lang="ts">
  import EventForm from '../components/EventForm.svelte';

  interface Props {
    params?: { id?: string };
  }
  let { params }: Props = $props();
</script>

{#key params?.id}
  <EventForm eventId={params?.id ?? null} />
{/key}
